import './ListicleItem.css';
import React from 'react';
import { get } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
export var ListicleItem = function ListicleItem(_ref) {
  var fields = _ref.fields,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 1 : _ref$index,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var moduleId = get(fields, 'data.item.id');
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('ListicleItem component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[ListicleItem component is empty: please provide datasource]");
    }
    return null;
  }
  var _fields$data = fields.data,
    videoAnalytics = _fields$data.videoAnalytics,
    prevNextNavAnalytics = _fields$data.prevNextNavAnalytics,
    navBubblesAnalytics = _fields$data.navBubblesAnalytics,
    readMoreAnalytics = _fields$data.readMoreAnalytics;
  var itemCaption = get(fields.data.item, 'caption.jss');
  var itemImage = get(fields.data.item, 'image.jss.value.src');
  var itemImageAlt = get(fields, 'data.item.image.jss.value.alt') || '';
  var videoSrc = get(fields.data.item, 'video.jss.value.href');
  var videoType = get(fields.data.item, 'video.jss.value.linktype');
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__media"
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__media-outer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__media-inner listicle__media-inner--poster-show"
  }, itemImage && /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    className: "listicle__image-box"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:1200px)",
    srcSet: "".concat(itemImage + '&cw=1420&ch=710')
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: "".concat(itemImage + '&cw=1180&ch=590')
  }), /*#__PURE__*/React.createElement("source", {
    media: "(max-width:768px)",
    srcSet: "".concat(itemImage + '&cw=325&ch=243')
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(itemImage + '&cw=1420&ch=710'),
    className: "listicle__img",
    alt: "".concat(itemImageAlt)
  })), videoSrc && /*#__PURE__*/React.createElement(Video, {
    buttonTopAlignment: true,
    className: "media-wrapper__video ",
    videoSrc: videoSrc,
    videoType: videoType,
    click: function click(e) {
      return tealiumClickFunc(tealiumMergeClickData(videoAnalytics, params), "".concat(e, ": ").concat(getLastPartInURL(videoSrc)));
    }
  }), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: "listicle__fav-btn test"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "listicle__caption body-small"
  }, " ", itemCaption && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: itemCaption,
    "data-cy": ""
  }))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    componentTabIndex: "disabled"
  }, children);
};
export var commonStyles = "czhyhj1";
export var ltrStyles = "l12bpxma";
export var rtlStyles = "r1feoyl9";
export default ListicleItem;